module.exports = __webpack_public_path__ + "static/media/community-video-black.33bcb43b.svg";